import { render, staticRenderFns } from "./CreateForm.vue?vue&type=template&id=bde48e3e&scoped=true"
import script from "./CreateForm.vue?vue&type=script&lang=ts"
export * from "./CreateForm.vue?vue&type=script&lang=ts"
import style0 from "./CreateForm.vue?vue&type=style&index=0&id=bde48e3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bde48e3e",
  null
  
)

export default component.exports